export enum SearchParam {
  ROSTER_ID = 'r',
  PATIENT_ID = 'p',
  FORM_ID = 'f',
  FORM_TYPE = 'f_type',
  FORM_ENCOUNTER = 'f_encounter',
  FORM_TEMPLATE = 'f_template',
  FORM_EVENT_TYPE = 'f_event_type',
  FORM_EVENT_DATE = 'f_event_date',
  MESSAGE_THREAD_ID = 'm',
  TASK_ID = 't',
  APPOINTMENT_ID = 'a',
  USER_ID = 'u',
  GROUP_ID = 'g',
  ORGANIZATION_ID = 'o',
  NOTIFICATION_EVENT_TYPE = 'n',
  REFERRAL_ID = 'referral_id',
  UNIT_ID = 'unit_id',
  EVENT_CONSUMER_ID = 'event_consumer_id',
  EDIT_FORM = 'f_edit',
  EDIT_PATIENT = 'p_edit',
  AWS_COMMUNICATIONS = 'aws_communications',
  WORKFLOW = 'wf',
  EDIT_WORKFLOW = 'wf_edit',
}

export const NEW_RESOURCE = 'NEW';

export const getSearchParams = (searchParams: URLSearchParams, keep: SearchParam[]) => {
  const newParams = new URLSearchParams();
  keep.forEach((param) => {
    if( searchParams.has(param)) {
      newParams.set(param, searchParams.get(param)!);
    }
  });
  return newParams;
};
